export default {
  office: {
    breadcrumbHome: 'Inicio',
    breadcrumbSolutions: 'Soluciones',
    breadcrumbCurrent: 'Oficina y consulta',
    hero: {
      eyebrow: 'Oficina y consulta',
      title: 'Vigilancia discreta para entornos de trabajo',
      lead: 'Recepción, pasillos, zonas sensibles: planificamos sistemas de cámaras que protegen sin inquietar a empleados ni pacientes.',
    },
    areas: {
      title: 'Áreas de uso en oficinas y consultas',
      lead: 'Las oficinas y consultas modernas necesitan seguridad discreta. Integramos las cámaras de forma sutil en la arquitectura.',
      items: {
        '0': { title: 'Recepción', desc: 'La primera impresión y el primer punto de vigilancia. Las cámaras de recepción documentan visitas y aseguran el acceso.' },
        '1': { title: 'Pasillos', desc: 'Los pasillos largos suelen ser puntos ciegos. Cámaras de techo compactas cierran los huecos con discreción.' },
        '2': { title: 'Salas de reuniones', desc: 'No toda reunión debe grabarse. Configuramos las cámaras para captar solo las zonas relevantes.' },
        '3': { title: 'Sala de servidores', desc: 'La sala donde están sus datos merece atención especial. Acceso y actividad se registran de forma fiable.' },
        '4': { title: 'Recepción de consulta', desc: 'En las consultas cuenta la discreción. Montamos cámaras discretas que protegen sin inquietar a los pacientes.' },
        '5': { title: 'Aparcamiento y entrada', desc: 'Los aparcamientos y entradas exteriores son especialmente vulnerables de noche. Cámaras resistentes con visión nocturna vigilan.' },
      },
    },
    access: {
      eyebrow: 'Acceso y control',
      title: '¿Quién puede ver qué?',
      lead: 'Un sistema de cámaras en la oficina solo se acepta si los derechos están claros. Configuramos derechos de acceso diferenciados y documentamos cada uso.',
      items: {
        '0': { title: 'Gestión de usuarios', desc: 'Cada persona recibe exactamente los derechos que necesita, de la vista en vivo a la reproducción.' },
        '1': { title: 'Enmascaramiento de privacidad', desc: 'Zonas como salas de descanso o vestuarios se ocultan técnicamente, en cámara o grabador.' },
        '2': { title: 'Registro de eventos', desc: '¿Quién vio qué y cuándo? Un registro de acceso completo permite un control trazable.' },
      },
    },
    privacy: {
      eyebrow: 'Protección de datos',
      title: 'Protección de datos en el trabajo',
      lead: 'Empleados y visitantes gozan de protección especial. Implementamos su vigilancia de forma conforme y justa, y le asesoramos en la documentación de la necesidad.',
      list: {
        '0': 'Grabar solo donde sea operativamente necesario',
        '1': 'Señalización para empleados y visitantes',
        '2': 'Sin vigilancia de vestuarios, aseos o salas de descanso',
        '3': 'Acceso a grabaciones solo para personas autorizadas',
        '4': 'Documentación de la necesidad operativa',
      },
      note: 'Nota: la vigilancia de lugares de trabajo está sujeta a estrictos requisitos legales. Le asesoramos técnicamente, sin sustituir el asesoramiento jurídico.',
    },
    cta: {
      title: 'Discreto. Respetuoso con la privacidad. Fiable.',
      lead: 'Planificamos su sistema de oficina o consulta para que proteja sin molestar en el día a día. Sin compromiso y con transparencia.',
      primary: 'Concertar una cita de asesoría',
      secondary: 'Iniciar el planificador de cámaras',
    },
  },
};